/* unplugin-vue-components disabled */import script from "./WebUrlPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WebUrlPage.vue?vue&type=script&setup=true&lang=js"

import "./WebUrlPage.vue?vue&type=style&index=0&id=13e3f925&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13e3f925"]])

export default __exports__